/**
 * Provides methods to interact with drawer-related local storage.
 */

class DrawerLocalStorage {
  // drawer state
  static expanded = true;

  // ls key
  static lsKey = 'expandedDrawer';

  /**
     * Get drawer component state.
     * @param {string} key - key.
     * @returns {any} value.
     */

  static getDrawerState() {
    const lsItem = localStorage.getItem(this.lsKey);
    return lsItem ? Boolean(Number(lsItem)) : true;
  }

  /**
     * Set drawer component state
     * @param {string} key - key.
     * @param {any} value.
     */

  static setDrawerState(value) {
    this.expanded = Number(value);
    this.save();
  }

  /**
     * Save drawer-related data to local storage.
     */

  static save() {
    localStorage.setItem(this.lsKey, this.expanded);
  }
}

export default DrawerLocalStorage;
